export function log() {
    if (process.browser && (process.env.NODE_ENV !== "production" || window.logsEnabled)) {
        console.warn.apply(null, arguments)
    }
}
